<template>
  <div class="kr-module-header">
    <span class="kr-module-header-sign"></span>
    <span class="kr-module-header-title">{{meta.name}}</span>
    <span class="kr-module-header-nodes" v-if="meta.nodes">{{meta.nodes}}</span>
  </div>
</template>

<script>
export default {
  name: 'krModuleHeader',
  props: {
    meta: kr.vue.getPropObject(),
  },
};
</script>

<style lang="scss">
  .kr-module-header {
    position: relative;
    left: -12px;
    margin-bottom: 12px;
    font-size: 0;
  }

  .kr-module-header-title {
    font-size: 14px;
    color: #525975;
    text-align: left;
    line-height: 21px;
    padding-right: 16px;
    font-weight: 500;
  }

  .kr-module-header-sign {
    display: inline-block;
    margin-right: 8px;
    width: 4px;
    height: 12px;
    background-color: $color-primary;
  }

  .kr-module-header-nodes {
    font-size: 12px;
    color: #9094a3;
    text-align: left;
    line-height: 18px;
  }
</style>
